export default "__VITE_ASSET__B0a2xqjd__"